import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {UserDetailOption} from '../../model/user-detail-option';

@Component({
  selector: 'user-detail-input',
  templateUrl: './user-detail-input.component.html',
  styleUrls: ['./user-detail-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailInputComponent implements OnInit, OnChanges {
  @Input() label: string;
  @Input() control: AbstractControl;
  @Input() type: string;
  @Input() inputType: string;
  @Input() options: UserDetailOption[] = [];
  @Input() menuButtonDisplay: string;
  @Input() lightText: boolean;
  @Input() showError: boolean;
  @Input() addNoneOption: boolean;

  // can't use control on the menus because some are string and some are string[]
  @Output() menuChange = new EventEmitter<UserDetailOption>();

  ngOnInit(): void {
    this.addNoneOptionToOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && this.options?.length && this.addNoneOption) {
      this.addNoneOptionToOptions();
    }
  }

  addNoneOptionToOptions() {
    const noneOption = this.options?.find(option => option.id === '' && option.display === 'None');
    if (!noneOption && this.addNoneOption) {
      this.options.unshift({id: '', display: 'None'});
    }
  }

  onMenuButton(event: MouseEvent) {
    event.preventDefault();
  }

  onOption(item: UserDetailOption) {
    this.menuChange.emit(item);
  }
}
